import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import baseURL from "../../config";

// MUI imports
import {
  Box,
  CircularProgress,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";

const ListOfCrewingAgentExecutive = () => {
  const { id: crewingAgentId } = useParams();
  const [executives, setExecutives] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchExecutives = async () => {
      try {
        const res = await axios.get(
          `${baseURL}/api/crewingAgentExecutive/crewingAgentExecutive/${crewingAgentId}`
        );
        setExecutives(res.data);
        console.log("Executives fetched:", res.data);
      } catch (error) {
        console.error("Error fetching executives:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchExecutives();
  }, []);

  if (loading)
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress sx={{ color: "#C30B12" }} />
      </Box>
    );

  return (
    <Box sx={{ p: 3,  minHeight: "100vh" }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: "#C30B12" }}>
        Executives of Crewing Agent:{" "}
        <Chip label={executives?.[0].crewingAgentName} sx={{ backgroundColor: "#FFD700", color: "#000" }} />
      </Typography>

      {executives.length === 0 ? (
        <Typography variant="body1" color="text.secondary">
          No executives found.
        </Typography>
      ) : (
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 3,
            boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
            overflow: "hidden",
          }}
        >
          <Table>
            <TableHead
              sx={{
                background: "linear-gradient(90deg, #C30B12, #FFD700)",
              }}
            >
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>Sr. No.</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>Name</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>Email</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>Created At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {executives.map((exec, index) => (
                <TableRow
                  key={exec._id}
                  hover
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#FFF3E0" : "#FFE0B2",
                    "&:hover": { backgroundColor: "#FFD700", color: "#000" },
                    transition: "0.3s",
                  }}
                ><TableCell>{index + 1}</TableCell>
                  <TableCell>{exec.name}</TableCell>
                  <TableCell>{exec.email}</TableCell>
                  <TableCell>{exec.phoneNumber}</TableCell>
                  <TableCell>
                    {new Date(exec.createdAt).toLocaleDateString("en-GB")}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default ListOfCrewingAgentExecutive;
